import { Tab, Tabs, TabsProps } from '@mui/material';
import { Link } from 'react-router';
import { StyleObj, TabConfigItem } from '../../../../@types';
import omit from 'lodash-es/omit';
import { mergeSx } from '../../../../utils/styles';

const styles: StyleObj = {
  tabs: {
    minHeight: 0,
    backgroundColor: 'neutral.700',
    '& .MuiTabs-list': { gap: 0 },
  },
  tab: {
    minHeight: 0,
    minWidth: 0,
    px: 1.5,
    py: 1.5,
    color: 'neutral.300',
    typography: 'body2',
    textTransform: 'none',
    '&.Mui-selected': {
      color: 'neutral.200',
    },
  },
};

type GolaTabsProps<T> = TabsProps & {
  tabConfig: TabConfigItem<T>[];
  linkPrefix?: string;
  customIndicatorColor?: string;
};

const GolaTabs = <T,>({ tabConfig, linkPrefix, customIndicatorColor, ...props }: GolaTabsProps<T>) => {
  return (
    <Tabs
      {...omit(props, 'setValue')}
      variant='scrollable'
      scrollButtons={false}
      sx={mergeSx(styles.tabs, {
        '& .MuiTabs-indicator': {
          backgroundColor: customIndicatorColor ?? 'neutral.300',
        },
      })}
    >
      {tabConfig?.map((tab) => (
        <Tab
          key={tab.value as string}
          component={linkPrefix ? Link : 'div'}
          label={tab.label}
          value={tab.value}
          to={linkPrefix ? `/${linkPrefix}/${tab.value}` : undefined}
          sx={styles.tab}
        />
      ))}
    </Tabs>
  );
};

export default GolaTabs;
